class HelloService {
	doHelloWorld() {
		return 'hello world';
	}

	static init() {
		return new HelloService();
	}
}

angular.module('app.hello', []).factory('serviceHello', HelloService.init);



// WEBPACK FOOTER //
// ./resources/WEB-INF/script/service/service.hello.es6.js